export default __webpack_public_path__ + "static/media/hidraulic17.0039f1a6.jpg";